import { render } from "./SquareItemList_IP.vue?vue&type=template&id=e50ba88e&scoped=true&ts=true"
import script from "./SquareItemList_IP.vue?vue&type=script&lang=ts"
export * from "./SquareItemList_IP.vue?vue&type=script&lang=ts"

import "./SquareItemList_IP.vue?vue&type=style&index=0&id=e50ba88e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e50ba88e"]])

export default __exports__